module.exports = __webpack_public_path__ + "static/img/tabbt2023_1.0c779e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tabbt2023_1.png
// module id = FLlA
// module chunks = 1